
export function handleSubmitSpecialCondition({
  connectApi,
  t,
  Swal,
  data,
  onSuccess,
  onError,
}) {
  return connectApi.post("api/Channels/UploadSCProcess", data, onSuccess)
    .catch((error) => {
      Swal.fire(
        "Error " + error?.response?.status,
        error?.response?.data,
        "error"
      );
      if (onError) onError(error);
    });
}

export const buildSpecialConditionFormData = ({
  specialConditionType,
  endUser,
  channel,
  category,
  series,
  endUserContactName,
  endUserContactPosition,
  startDate,
  effectiveMonths,
  percentage,
  minimumImp,
  justification,
  competition,
  objetive,
  resultFuture,
  comments,
  opdNumber,
  endUserEmail,
  selectedPressListToUpload,
  compensationTable,
  bonusTable,
  bonusLSDiscountSend,
  combineClicksToUpload,
  MinimumPrint,
  multiplierConfig,
  minumimDiscount,
}) => {
  const data = new FormData();

  data.append("idSpecialConditionType", specialConditionType);
  data.append("idEndUser", endUser);
  data.append("idCustomer", channel);

  if (category == 1) data.append("category", "Special Condition");
  else if (category == 2) data.append("category", "Ramp up");
  else data.append("category", "Ramp up Ligada");

  data.append("serie", series);
  data.append("endUserContactName", endUserContactName);
  data.append("endUserContactPosition", endUserContactPosition);

  data.append(
    "startDate",
    new Date(startDate).getFullYear() +
      "-" +
      (new Date(startDate).getMonth() + 1).toString().padStart(2, "0") +
      "-01"
  );

  let endDateTransform = new Date(startDate);
  endDateTransform.setMonth(endDateTransform.getMonth() + (Number(effectiveMonths) + 1));
  endDateTransform.setDate(0);

  let secondTransform = endDateTransform.toISOString().split("T")[0];
  data.append("endDate", secondTransform);
  data.append("effectiveMonths", effectiveMonths);

  if ((series >= 4) && (specialConditionType === 21)) {
    data.append("percentage", ((percentage === "" ? 0 : percentage) / multiplierConfig) * 100);
  } else {
    if (specialConditionType === 11) {
      data.append("percentage", minumimDiscount);
    } else {
      data.append("percentage", percentage === "" ? 0 : percentage);
    }
  }

  data.append("minimumImp", minimumImp);
  data.append("justification", justification);
  data.append("competition", competition);
  data.append("objetive", objetive);
  data.append("resultFuture", resultFuture);
  data.append("comments", comments);
  data.append("opd", opdNumber);
  data.append("createdBy", endUserEmail);
  data.append("pressList", JSON.stringify(selectedPressListToUpload));
  data.append("compensationTable", JSON.stringify(compensationTable));
  data.append("bonusTable", JSON.stringify(bonusTable));
  data.append("bonusLSDiscountTable", JSON.stringify(bonusLSDiscountSend));
  data.append("combineClicks", JSON.stringify(combineClicksToUpload));
  data.append("minimumPrint", MinimumPrint);

  return data;
};